import React from "react";
import {
  Container,
  Form,
  Button,
  Header,
  Divider,
  Segment
} from "semantic-ui-react";
import RoomPicker from "./roomPicker/roomPickerContainer";
import DateRangePicker from "./dateRangePicker/DateRangePickerContainer";

const ScheduleCleaningComponent = ({
  cleaners,
  selectedCleaner,
  setCleaner,
  saveCleaning,
  history,
  t,
  checked,
  toggleCheckBox
}) => (
  <Segment basic>
    <Header as={"h1"}>{t("cleaning:scheduleCleaningHeaderText")}</Header>
    <Segment>
      <Form as="form">
        <Form.Select
          options={cleaners.map(cleaner => ({
            value: cleaner.userId,
            text:
              cleaner.firstname && cleaner.surname
                ? `${cleaner.firstname} ${cleaner.surname}`
                : cleaner.email
          }))}
          onChange={(proxy, input) => setCleaner(input.value)}
          value={selectedCleaner}
          label={t("cleaning:selectCleanerText")}
        />
        <Form.Field>
          <label>{t("cleaning:selectDatesText")}</label>
          <Form.Group>
            <DateRangePicker />
          </Form.Group>
        </Form.Field>
        <Form.Field>
          <Form.Checkbox
            value={checked}
            onChange={toggleCheckBox}
            label={t("cleaning:showScheduledCheckboxText")}
          />
        </Form.Field>
        <Form.Field>
          <label>{t("cleaning:selectRoomsToCleanText")}</label>
          <RoomPicker checked={checked} />
        </Form.Field>
        <Divider />
        <Button
          color="blue"
          onClick={() => {
            saveCleaning(() => history.goBack());
          }}>
          {t("common:saveText")}
        </Button>
        <Button onClick={() => history.goBack()}>
          {t("common:cancelText")}
        </Button>
      </Form>
    </Segment>
  </Segment>
);

export default ScheduleCleaningComponent;



// WEBPACK FOOTER //
// ./src/cleaning/schedule/ScheduleCleaningComponent.js